import { createActions } from '../utils/actions';

const { actions: scheduleListings } = createActions('schedule.listings')
  .add('bootstrap')
  .add('cleanUp')
  .addAsync('getListings')
  .addAsync('publish')
  .addAsync('reschedule')
  .add('setData')
  .add('setModal')
  .add('setTimeRange')
  .add('toggleProduct');

export default scheduleListings;
